import { AddStockGroupPayloadType } from "../../../../../commonTypes/clientSettingsTypes";
import { AllGroupStockListType } from "../../../../../redux/clientSettings/clientSettingTypes";
import {  formateDateWithTime } from "../../../../../utils/commonFunctions";
import UpdatedByAndUpdatedAt from "../../../../commons/CommonUpdatedByAndUpdatedAt";

type AppProps = {
  menuDetails: any;
  handleEditStockGroupDetails: (data: AddStockGroupPayloadType) => void;
  indentation: number;
  parent:string;
  isEditStockGroupPresent?:boolean;
};

const NestedTables = ({
  menuDetails,
  handleEditStockGroupDetails,
  indentation,
  parent,
  isEditStockGroupPresent
}: AppProps) => {
  return (
    <>
      <tr>
        <td className="text-start">{menuDetails?.stock_group_id}</td>
        <td style={{ paddingLeft: `${indentation * 10}px` }}>
          <span
            className={indentation === 0.7 ? "" : "stock-nested-list no-show"}
          >
            {menuDetails?.stock_group_name}
          </span>
        </td>
        <td className="text-start">{parent?parent:""}</td>
        <td>
        <UpdatedByAndUpdatedAt
            firstName={menuDetails?.updated_by?.first_name}
            lastName={menuDetails?.updated_by?.last_name}
            profilePic={menuDetails?.updated_by?.profile_pic?.file_url}
            updatedAt={formateDateWithTime(menuDetails?.updated_at)}
          />
        </td>
        <td style={{ width: "80px", textAlign: "center" }}>
          {isEditStockGroupPresent && <span
            className="d-inline-block pointer"
            onClick={() => handleEditStockGroupDetails(menuDetails)}
          >
            <div
              style={{
                color: "#d43",
                fontSize: 20,
              }}
            >
              <i className="fas fa-pen"></i>
            </div>
          </span>}
        </td>
      </tr>
      {menuDetails.tree_data?.length > 0 &&
        menuDetails?.tree_data.map((dataItem: AllGroupStockListType) => {
          return (
            <NestedTables
              menuDetails={dataItem}
              handleEditStockGroupDetails={handleEditStockGroupDetails}
              indentation={indentation + 1}
              parent={menuDetails.stock_group_name}
              isEditStockGroupPresent={isEditStockGroupPresent}
            />
          );
        })}
    </>
  );
};
export default NestedTables;
